import React, { Fragment } from 'react';

import { ajax, /*ProfileLevels,*/ myDeepCopy, setEmptyStrings } from '../components/globals';
import { Languages } from '../components/languages';

import {
    UCardTitle, UButton, InputSection, MessageBox, UserCard, ULink
} from '../components/utilities';

import {
    loadCreditBoxPackets, getCreditWalletInfo
} from '../components/globals';

import {
    SendaPayPalButton
} from '../components/sendaPaypalButton';
import {
    MonetaWebButton
} from '../components/monetaWebButton';
import { UISummary, UIFilterPanel, UISummaryWidget, UISummaryWidgetBar, PageTitle, UIDataTable, UIDownload, ScrollableGrid, ScrollableGridItem, UIPopup, UIInput, UIButton, UIButtonPad, UICheckbox, UIMessageBox, UISelect, UIMultiSelect } from '../components/guiElements';



export default class CreditBox extends React.Component {
    constructor(props) {
        super(props);

        this.onError = this.onError.bind(this);
        this.onSuccess = this.onSuccess.bind(this);
        this.loadCreditWallet = this.loadCreditWallet.bind(this);
        this.updateSelection = this.updateSelection.bind(this);
        //this.onMonetaWebPopUp = this.onMonetaWebPopUp.bind(this);
        this.uc = JSON.parse(sessionStorage.getItem("userContext"));
        this.le = Languages.getSection('CreditBox');
        this.leMain = Languages.getSection('Main');
        

        
        
        this.state = {
            creditPackets: [],
            creditWalletInfo: { total: null, expiringWhen:null},
            currentPacketId:''
        };
        
    }

    //#region Events

    componentDidMount() {

        try {

            this.props.loaderShow(0);
            loadCreditBoxPackets(this,this.uc.jwtToken, listOf => {
                this.props.loaderHide();

                let creditList = listOf.map((item) => { return Object.assign(item, {checked:false}); });

                this.setState({ creditPackets: creditList});
            },
                ko => {

                    this.props.loaderHide();
                });

        }
        catch (e) {
            this.props.loaderHide();
            const msg = this.leMain.messages.msgError;
            this.props.popupErrorMessage(msg);
        }

        this.loadCreditWallet();
        

    }
    loadCreditWallet() {
        try {

            getCreditWalletInfo(this.uc.jwtToken, data => {

                this.setState({ creditWalletInfo: data.wallet });
            },
                ko => {

                }, this);

        }
        catch (e) {

        }

    }
    updateSelection(ev, id) {

        ev.preventDefault();
        ev.stopPropagation();
        if (id)
        {
            let creditPackets = this.state.creditPackets;
            let el = creditPackets.find((a) => a.id == id);
            if (el) {
                el.checked = !el.checked;
                creditPackets.forEach((a) => a.id !== id ? a.checked = false : a.checked = a.checked);

                this.setState({ creditPackets: creditPackets, currentPacketId: (el.checked?el.id:'') });
            }
        }
    }

    onError(error) {

        const msg = this.le.messages.error;
       

        this.props.popupErrorMessage(msg.messages);

    }
    onSuccess(data) {

        let me = this;
        let exitPopUp = function () {
        }

        me.loadCreditWallet();

        const msg = this.le.messages.purchaseOk;
        let obj = {
            title: msg.captions[0],
            width: "35%",
            icon: "info",
            messages: msg.messages,
            buttons: [{ name: "ok", type: "confirm", width: "40%", text: "ok", class: "right", click: exitPopUp }]
        };

        try {

        }
        catch (e) { }

        this.props.popupMessage(obj);

    }
    /*onMonetaWebPopUp(popup) {

        let me = this;
        setTimeout(function () {

            try {

                if (popup.closed)
                    me.loadCreditWallet();

            }
            catch (e) {

            }
        }, 500);

        
    }*/
    render() {

        let modal = "";

        /*let credits = this.state.creditPackets.map((item, index) => {

            return (
                <div className="row ucheckbox blue" >
                    <div className="col">
                        <div className="ucheckbox" onClick={this.handleClick} value={item.id}>
                            <input id={item.id} checked={item.checked} value={item.id} type="checkbox" />
                            <span value={item.id} className="checkmark"></span>
                            <h4 value={item.id} style={{ marginLeft: "2rem" }}>{item.credit} Crediti {item.cost} Euro</h4>
                    </div>
            </div></div>);

        });*/

        let rows = this.state.creditPackets.map((item, idx) => (
            [
                <div className="entry-list-row-panel entry-list-row-link" key={"entrylist-panel-1-" + idx} onClick={ev => this.updateSelection(ev, item.id)}>
                    <div className={"entry-list-status " + (item.checked ? '' : 'off')}></div>
                    <div>{item.credit + ' ' + this.le.products.credits}</div>
                </div>,
                <div className="entry-list-row-panel entry-list-row-link" key={"entrylist-panel-2-" + idx} onClick={ev => this.updateSelection(ev, item.id)}>
                </div>,
                <div className="entry-list-row-panel entry-list-row-link" key={"entrylist-panel-3-" + idx} onClick={ev => this.updateSelection(ev,item.id)}>
                    <div className="entry-list-text">{item.cost} Euro</div>
                </div>
            ]
        ));



        if (this.state.creditPackets && this.state.creditPackets.length > 0)
            this.packetId = this.state.creditPackets[3].id;


        return  <div className="page-creditbox">
            <PageTitle icon="../images/mainMenu/Orders.png" title={Languages.getSection('Main').menuLabels.orderCredits} />
            <div className="page-content">

                <UISummary>
                    <UISummaryWidgetBar>
                        <UISummaryWidget key={"sum-totals"} className=""
                            title={this.le.summary.title} 
                            mainLabel={this.le.summary.sub1} 
                            mainScore={this.state.creditWalletInfo.total != null ? this.state.creditWalletInfo.total : this.le.summary.na}
                            subLabel={this.le.summary.sub2} 
                            subScore={this.state.creditWalletInfo.expiringWhen != null ? this.state.creditWalletInfo.expiringWhen : this.le.summary.na} />
                    </UISummaryWidgetBar>
                </UISummary>


                <div className="widget buy-credits">
                    <div className="widget-content for-entry-list">
                        <div className="entry-list" key="entrylist">
                            <div className="entry-list-row-panel entry-list-row-header">
                                <div>{this.le.products.title}</div>
                            </div>
                            <div className="entry-list-row-panel entry-list-row-header" />
                            <div className="entry-list-row-panel entry-list-row-header">
                                <div className="">{this.le.products.cost}</div>
                            </div>
                            {rows}
                        </div>
                        <UIButtonPad align="right">
                            <MonetaWebButton
                                title={this.le.products.payCDC}
                                loaderShow={this.props.loaderShow}
                                loaderHide={this.props.loaderHide}
                                jwtToken={this.uc.jwtToken}
                                packetId={this.state.currentPacketId}
                                disabled={this.state.currentPacketId != '' ? false : true}
                                onError={this.onError}
                                onSuccess={this.onSuccess}
                            />

                            <SendaPayPalButton
                                loaderShow={this.props.loaderShow}
                                loaderHide={this.props.loaderHide}
                                jwtToken={this.uc.jwtToken}
                                packetId={this.state.currentPacketId}
                                disabled={this.state.currentPacketId != '' ? false : true}
                                onError={this.onError}
                                onSuccess={this.onSuccess}
                            />
                        </UIButtonPad>
                    </div>
                    <div className="widget-footer">
                    </div>
                </div>

            </div>
        </div>;




            /*
            <div id={this.constructor.name}>
                <div className="container-fluid ucard">
                    <UCardTitle text={this.le.title} />
                    <div style={{ marginTop: "4rem", borderTop: "2px solid #d3d3d3", marginBottom: "3rem" }} />
                    <div className="row">
                        <div className="col-4">
                            <div className="container-fluid ugrand-totals">
                                <div className="row title">
                                    <div className="void"></div>
                                    <div className="bold upper"><h1>TOTALE CREDITI</h1>
                                        <div className="void"></div>
                                    </div>
                                    <div></div>
                                    <div name="cashed" className="ugrand-total-entry">
                                        <div></div>
                                        <div className="row">
                                            <div className="col">
                                                <h1 className="ugrand-total white">{this.state.creditWalletInfo.total}</h1><h1 className="ugrand-total">Disponibili</h1></div>
                                        </div>
                                        <div className="className">
                                            <div className="col">
                                                <h5>crediti disponibili per le spedizioni</h5>
                                            </div>
                                        </div>
                                        <div></div>
                                    </div>
                                    <div name="cashed" className="ugrand-total-entry">
                                        <div></div>
                                        <div className="row">
                                            <div className="col">
                                                <h1 className="ugrand-total white">{this.state.creditWalletInfo.expiringWhen}</h1><h1 className="ugrand-total">Scadenza</h1></div>
                                        </div>
                                        <div className="className">
                                            <div className="col">
                                                <h5>scadenza per l'uso dei crediti</h5>
                                            </div>
                                        </div>
                                        <div></div>
                                    </div>
                                 </div>
                            </div>
                        </div>
                    </div>
                    
                    <div style={{ marginTop: "5rem" }} />
                    <div className="row">
                        <div className="col">
                            
                                {credits}
                                
                        </div>
                        <div className="col">
                            <div className="row">
                                <div className="col">
                                    <MonetaWebButton
                                        loaderShow={this.props.loaderShow}
                                        loaderHide={this.props.loaderHide}
                                        disabled={this.state.currentPacketId != '' ? false : true}
                                        jwtToken={this.uc.jwtToken}
                                        packetId={this.state.currentPacketId}
                                        disabled={this.state.currentPacketId != '' ? false : true}
                                        onError={this.onError}
                                        onSuccess={this.onSuccess}
                                        onPopup={this.onMonetaWebPopUp}
                                    />
                                </div>
                                
                            </div>
                                <div className="row">
                                <div className="col-8">
                                    <SendaPayPalButton
                                        loaderShow={this.props.loaderShow}
                                        loaderHide={this.props.loaderHide}
                                        jwtToken={this.uc.jwtToken}
                                        packetId={this.state.currentPacketId}
                                        disabled={this.state.currentPacketId!=''?false:true}
                                        onError={this.onError}
                                        onSuccess={this.onSuccess}
                                    ></SendaPayPalButton>
                                    <h3>Acquista con Paypal</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{ marginTop: "2rem" }} />
                    {modal}
                </div>
            </div>*/
    }
}

